import { render, staticRenderFns } from "./AddSignerDialog.vue?vue&type=template&id=09fd9770&scoped=true&"
import script from "./AddSignerDialog.vue?vue&type=script&lang=js&"
export * from "./AddSignerDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddSignerDialog.vue?vue&type=style&index=0&id=09fd9770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd9770",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBanner,VCard,VSpacer,VToolbar})
